import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

type Props = {
  value?: Array<string> | string;
  label_class: string;
  id: string;
  label: string;
  name: string;
  input_class: string;
  tag_class: string;
  handler: (value: string, name: string) => void;
  merit_text?: string;
};

const TagInput: React.FC<Props> = ({
  value,
  label_class,
  id,
  label,
  name,
  input_class,
  tag_class,
  handler,
  merit_text,
}) => {
  const { t } = useTranslation();
  const [tags, setTags] = useState<string[]>([]);
  const [currentInput, setCurrentInput] = useState<string>("");

  useEffect(() => {
    if (value === "") {
      return setTags([]);
    }

    if (typeof value === "string") {
      return setTags([...value.split(" ")]);
    }

    if (Array.isArray(value)) {
      return setTags([...value]);
    }

    setTags([]);
  }, [value]);

  const addTag = () => {
    if (currentInput) {
      const curTags = [...tags];
      curTags.push(currentInput.toLowerCase());
      setTags(curTags);
      setCurrentInput("");

      handler(curTags.join(" "), name);
    }
  };

  const removeTag = (i: number) => {
    if (i >= 0) {
      const curTags = [...tags];
      curTags.splice(i, 1);
      setTags(curTags);

      handler(curTags.join(" "), name);
    }
  };

  const handleKeys = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.nativeEvent.isComposing === true) {
      return;
    }
    switch (event.key) {
      case " ":
      case "Enter":
        event.preventDefault();
        addTag();
        break;
      case "Backspace":
        if (!currentInput) {
          event.preventDefault();
          removeTag(tags.length - 1);
        }
        break;
      default:
        // 入力が確定&全角スペース
        if (event.code === "Space") {
          addTag();
          return;
        }
        break;
    }
  };

  return (
    <>
      <label className={label_class} htmlFor={id}>
        {t(label)}
      </label>
      {merit_text ? <p>{merit_text}</p> : null}
      <div className={input_class}>
        {tags.map((el, i) => (
          <span key={i} className={tag_class}>
            {`#${el}`}
            <button type="button" onClick={() => removeTag(i)}>
              <FontAwesomeIcon icon={["fas", "times"]} />
            </button>
          </span>
        ))}
        <input
          type="text"
          value={currentInput}
          onChange={(event) => {
            setCurrentInput(event.target.value.trim());
          }}
          onKeyDown={handleKeys}
          id={id}
          name={name}
          size={currentInput.length + 2}
          enterKeyHint="done"
        />
      </div>
    </>
  );
};

export default TagInput;
